module.exports = __webpack_public_path__ + "static/img/contact-us.4b68985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact-us.jpg
// module id = SkcH
// module chunks = 13